import './app.css';

import '@babel/polyfill';

/* eslint-disable no-unused-vars*/
/* eslint-disable no-console*/

import {TweenMax} from 'gsap';

/* eslint-disable no-useless-escape*/
let isMobile = false; 
if(/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|ipad|iris|kindle|Android|Silk|lge |maemo|midp|mmp|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows (ce|phone)|xda|xiino/i.test(navigator.userAgent) 
    || (/1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i).test(navigator.userAgent.substr(0, 4))) {isMobile = true;}
/* eslint-enable no-useless-escape*/


/* is production */
const isProd = process.env.NODE_ENV === 'production';


/* meta */
const meta = require('./js/meta.json');

/* data [UNCOMMENT THE LINE BELOW TO USE TEXTS FROM DATA IN JS] 
const data = require('./js/data.json');*/

/* rellax */

/*
const Rellax = require('rellax');
const rellaxReload = () => {
    const rlx = document.getElementsByClassName('rellax');
    if (rlx[0]) {
        new Rellax('.rellax', {
            speed: -2,
            round: true,
            center: true
        });
    }
}
*/



const Rellax = require('rellax');

let rellax;


const articles = [...document.querySelectorAll('.section')];
const rellaxes = [];

const enableRellax = artNum => {
  articles.forEach(article => {
    let articleNum = article.dataset.section;
    articleNum = parseInt(articleNum, 10);
    if (articleNum === artNum) {
      if ([...document.querySelectorAll(`[data-section="${articleNum}"] .rellax`)].length > 0) {
      rellaxes[articleNum - 1] = Rellax(`[data-section="${articleNum}"] .rellax`, {
            center: true
        });
      }
    }
  });
}

const disableRellax = artNum => {
  if (artNum < 2) return;
  if(rellaxes[artNum - 1]) {
rellaxes[artNum - 1].destroy();

  }
}


const articleChecker = (enter, artNumber) => {
  artNumber = parseInt(artNumber, 10);
  if (enter) {
    enableRellax(artNumber)
  } else {
    disableRellax(artNumber)
  }
}

/*
const setRellax = () => {

    rellax = Rellax('.rellax', {
        speed: 2,
        round: true,
        center: true
    });

};



window.addEventListener('resize', () => {
    rellaxControl.update();
});

window.addEventListener('load', () => {
    rellaxControl.update();
}, false);


const rellaxControl = {

    update: function () {
      
        if (rellax)
            rellax.destroy();
        if (!isMobile) {
        setRellax();
        }
      
    }
}
*/

/* InView rellax trigger */



const inViewRellax = require('in-view');

const initRellaxInView = () => {

inViewRellax('.section')
    .on('enter', elem => {
      articleChecker(true, elem.dataset.section);
    })
    .on('exit', elem => {
      articleChecker(false, elem.dataset.section);
    });
}

inViewRellax.offset({
        top: -200,
        bottom: -200
    });


/* analytics */
/* SEND EVENT: analyticsEvent('Button', 'click', 'Play'); */



const analyticsEvent = (category, action, label) => {
    const dataLayer = window.dataLayer = window.dataLayer || [];

    dataLayer.push({
        event: 'eventTracking',
        category: category,
        action: action,
        label: label
    });
};



/* track events from html attributes */
const trackingElements = document.querySelectorAll('[data-event][data-event-category][data-event-label]');

if (trackingElements.length > 0) {
    trackingElements.forEach(trackingElem => {
        trackingElem.addEventListener(trackingElem.getAttribute('data-event'), () => {
            analyticsEvent(
                trackingElem.getAttribute('data-event-category'),
                trackingElem.getAttribute('data-event'),
                trackingElem.getAttribute('data-event-label')
            );
        });
    });
}

/* image lazy load */

[].forEach.call(document.querySelectorAll('img[data-src]'), function (img) {
    img.setAttribute('src', img.getAttribute('data-src'));
    img.onload = function () {
        img.removeAttribute('data-src');
    };
});


/* fonts */
const WebFont = require('webfontloader');

WebFont.load({
    custom: {
        families: ['Formular:n4,n5'],
        urls: ['./css/fonts.css']
    },
    google: {
        families: ['Roboto:300,400,500,700,900:cyrillic']
    }
});



/* share */
import * as VanillaSharing from 'vanilla-sharing';

const shareButtons = [...document.querySelectorAll('.share__item')];

if (navigator.share !== undefined) {
    document.querySelector('.share__item--all').classList.add('share__item--show');
}

if (shareButtons.length > 0) {

    const shareOptions = {
        url: meta.url,
        title: meta.title,
        description: meta.description,
        image: meta.image,
        isVkParse: false,
        fbAppId: meta.fbappid
    };

    shareButtons.forEach(button => {
        button.addEventListener('click', () => {
            if (button.dataset.social === 'all' && navigator.share !== undefined) {
                navigator.share({
                    title: shareOptions.title,
                    url: shareOptions.url
                });
            } else {
                VanillaSharing[button.dataset.social](shareOptions);
            }

            analyticsEvent('Share', 'click', 'Social: ' + button.dataset.social);
        });
    });

}


/* in view */
const inView = require('in-view');

inView('#roskosimg')
    .on('enter', elem => {
        elem.setAttribute('data-inview', 'true');
    })

inView('.text-block')
    .on('enter', elem => {
        elem.setAttribute('data-inview', 'true');
    })
    .on('exit', elem => {
        elem.removeAttribute('data-inview');
    });

inView.offset({
        top: 200,
        bottom: 300
    });


/* video play */


const inViewVideo = require('in-view');
const videos = [...document.querySelectorAll('.planet--video')];

videos.forEach(video => {
  video.loop = true;
})

inViewVideo.offset({
        top: -100,
        bottom: -100
    });

inViewVideo('.planet--video')
    .on('enter', elem => {
        elem.play();
    })
    .on('exit', elem => {
        elem.pause();
    });


/* service worker */
if ('serviceWorker' in navigator && isProd) {
    window.addEventListener('load', () => {
        navigator.serviceWorker.register('./sw.js');
    });
}


/* smooth scroller */
const html = document.documentElement;
const body = document.body;

const scroller = {
  target: document.querySelector('#scroll-container'),
  ease: 0.05, // <= scroll speed
  endY: 0,
  y: 0,
  resizeRequest: 1,
  scrollRequest: 0
};

let requestId = null;

TweenMax.set(scroller.target, {
  rotation: 0.01,
  force3D: true
});

const scrollBottom = () => {
  const contHeight = document.querySelector('#scroll-container').clientHeight;
  body.style.height = contHeight + 'px';
  
  window.scrollTo(0, contHeight);
  TweenMax.set(scroller.target, { 
    y: -contHeight + window.innerHeight
  });
}

const startScroller = () => {
  updateScroller();
  window.addEventListener('resize', onResize);
  document.addEventListener('scroll', onScroll);
}

function onLoad() { 
  window.focus();
  setTimeout(() => {
    scrollBottom();
    if (!isMobile) {
      initRellaxInView();
      /*
      setRellax();
      rellaxReload();
      */
    }   
    startScroller();
    
    body.setAttribute('data-started', 'true');
    setTimeout(() => {
      document.querySelector('.viewport__fade').classList.remove('active');
    }, 1000);
    
  }, 100);

}
window.addEventListener('load', onLoad);


function updateScroller() {
  
  const resized = scroller.resizeRequest > 0;
    
  if (resized) {    
    const height = scroller.target.clientHeight;
    body.style.height = height + 'px';
    scroller.resizeRequest = 0;
  }
      
  const scrollY = window.pageYOffset || html.scrollTop || body.scrollTop || 0;

  scroller.endY = scrollY;
  scroller.y += (scrollY - scroller.y) * scroller.ease;

  if (Math.abs(scrollY - scroller.y) < 0.05 || resized) {
    scroller.y = scrollY;
    scroller.scrollRequest = 0;
  }
  
  TweenMax.set(scroller.target, { 
    y: -scroller.y,
    force3D: true
  });

  scroller.target.dataset.offset = Math.round(scroller.y);
  
  requestId = scroller.scrollRequest > 0 ? requestAnimationFrame(updateScroller) : sideMenuWatch();
}

function onScroll() {
  sideMenuWatch();
  scroller.scrollRequest++;
  if (!requestId) {
    requestId = requestAnimationFrame(updateScroller);
  }
}

function onResize() {
  scroller.resizeRequest++;
  if (!requestId) {
    requestId = requestAnimationFrame(updateScroller);
  }
}

/* aside pannel */

const sideMenuLinks = [...document.querySelectorAll('#sidepanel li')];
const articleParts = [...document.querySelectorAll('.part-header')];
const articlePartsCoords = [];
const scrollContainer = document.querySelector('#scroll-container');

articleParts.forEach(article => {
  let arrayNum = parseInt(article.dataset.part, 10);
  arrayNum -= 1;
  articlePartsCoords[arrayNum] = article.getBoundingClientRect().bottom;
});

const deactivateMenu = linkNum => {
  sideMenuLinks.forEach(link => link.classList.remove('active'))
}

const activateMenu = linkNum => {
  if (sideMenuLinks[linkNum - 1].classList.contains('active')) {
    return;
  } else {
  sideMenuLinks.forEach(link => link.classList.remove('active'));
  sideMenuLinks[linkNum - 1].classList.add('active');
  }
}


const goToAnchor = linkNum => {
  const linkArrayNum = parseInt(linkNum, 10) - 1;
  setTimeout(() => {
    sideMenuWatch();
  }, 1500);

  window.scrollTo(0, articlePartsCoords[linkArrayNum] - window.innerHeight - 2)
  /*
  articleParts.forEach(article => {
    
    console.log(article.getBoundingClientRect().bottom);
    
    if (article.dataset.part === linkNum) {
      console.log(article.getBoundingClientRect().top)
      window.scrollTo(0, article.getBoundingClientRect().bottom);
    }
    

  })*/
}

sideMenuLinks.forEach(link => {
  link.addEventListener('click', () => {
    goToAnchor(link.dataset.anchor);
  })
})

const sideMenuWatch = () => {
  if (scrollContainer.dataset.offset < articlePartsCoords[0] && scrollContainer.dataset.offset > articlePartsCoords[1]) {
    activateMenu(4);
  } else if(scrollContainer.dataset.offset < articlePartsCoords[1] && scrollContainer.dataset.offset > articlePartsCoords[2]) {
    activateMenu(3);
  } else if (scrollContainer.dataset.offset < articlePartsCoords[2] && scrollContainer.dataset.offset > articlePartsCoords[3]) {
    activateMenu(2);
  } else if (scrollContainer.dataset.offset < articlePartsCoords[3]) {
    activateMenu(1);
  } else {
    deactivateMenu();
  }
}


/*
articleParts.forEach(article => {
  console.log(article.getBoundingClientRect().bottom);
})
*/


/* analythic events */

analyticsEvent('Page', 'event', 'Load');

document.querySelector('.gazeta-link').addEventListener('click', () => {
  analyticsEvent('Link', 'click', 'Gazeta.ru');
})

document.querySelector('.roskone').addEventListener('click', () => {
  analyticsEvent('Link', 'click', 'station click');
})

document.querySelector('.rosktwo').addEventListener('click', () => {
  analyticsEvent('Link', 'click', 'glonas click');
})

document.querySelector('.roskthree').addEventListener('click', () => {
  analyticsEvent('Link', 'click', 'Superheavy click');
})

document.querySelector('.roskfour').addEventListener('click', () => {
  analyticsEvent('Link', 'click', 'Sealaunch click');
})

document.querySelector('.roskfive').addEventListener('click', () => {
  analyticsEvent('Link', 'click', 'New Missions click');
})

document.querySelector('.rosksix').addEventListener('click', () => {
  analyticsEvent('Link', 'click', 'Federation click');
})


// WEBPACK FOOTER //
// ./app.js